<template>
  <div id="identity-provider-step">
    <div>
      <p class="text-lighter mb-20">
        Copy the Identifier and Reply URL from Hubstaff into your Identity provider’s configuration.
      </p>

      <div class="mb-10">
        <label class="control-label is-uppercase">Identifier (Entity ID)</label>
        <div class="d-flex">
          <AppInput
            disabled
            :value="computedIssuer"
            class="flex-grow-1"
          />
          <button
            class="btn btn-outline-primary text-blue ml-10"
            type="button"
            @click="copyToClipboard(computedIssuer)"
          >
            <i class="hi hi-file" />
            Copy
          </button>
        </div>
      </div>

      <div class="mb-10">
        <label class="control-label is-uppercase">Reply URL (Assertion Consumer Service URL)</label>
        <div class="d-flex">
          <AppInput
            disabled
            :value="computedAssertionConsumerServiceUrl"
            class="flex-grow-1"
          />
          <button
            class="btn btn-outline-primary text-blue ml-10"
            type="button"
            @click="copyToClipboard(computedAssertionConsumerServiceUrl)"
          >
            <i class="hi hi-file" />
            Copy
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdentityProviderStep',
  props: {
    sso: {
      type: Object,
      required: true,
      default: () => ({
        hubstaff_assertion_consumer_service_url: '',
        hubstaff_issuer: '',
      }),
    },
    ssoSpAcsUrl: {
      type: String,
      required: true,
    },
    ssoSpEntityId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    computedAssertionConsumerServiceUrl() {
      return this.sso?.hubstaff_assertion_consumer_service_url || this.ssoSpAcsUrl;
    },
    computedIssuer() {
      return this.sso?.hubstaff_issuer || this.ssoSpEntityId;
    },
  },
  methods: {
    copyToClipboard(text) {
      const tempInput = document.createElement('input');

      tempInput.value = text;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      this.$appMessage('Copied to clipboard');
    },
  },
};
</script>
